import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '~/components/Modal/Modal';
import { useModalSlotSelectDate } from '~/components/ModalSlotsSelectDateCD/hooks';
import { useGlobal } from '~/hooks/useGlobal';

import { checkoutStore, mainStore } from '~/stores';

import { ModalBody, ModalFooter, ModalHeader } from '../ModalComponents';

import { DateSelector, SlotList } from './components';
import styles from './ModalSlotsSelectDateCD.module.scss';

const ModalSlotsSelectDateCD: FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useGlobal();

  const {
    selectedDate,
    selectedSlotId,
    handleSelectSlot,
    handleSplit,
    shouldSplitSlot,
    setSelectedDate,
    onChangeSlotId,
    timeStamps,
    deliverySlots,
    closeModal,
    currentDelivery,
  } = useModalSlotSelectDate();

  if (!currentDelivery) {
    closeModal();
    return null;
  }

  const order = checkoutStore.slotSelectionModalStore.selectedOrder;

  if (!order) {
    return null;
  }

  const priceWithoutDelivery = +mainStore.convertPenceToPounds(
    order.paid_without_delivery,
  );

  return (
    <Modal
      isShow={true}
      className={styles.slotSelect}
      onBackdropDismiss={() => closeModal()}
    >
      <div className={styles.slotSelect__container}>
        <ModalHeader
          onClose={closeModal}
          title={t('checkout:selectDeliveryTime')}
          className={styles.slotSelect__header}
        />
        <ModalBody className={styles.slotSelect__body}>
          <DateSelector
            timeStamps={timeStamps}
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
            deliverySlots={deliverySlots}
          />
          <SlotList
            selectedDate={selectedDate}
            selectedSlotId={selectedSlotId}
            deliverySlots={deliverySlots}
            onSlotSelect={onChangeSlotId}
            priceWithoutDelivery={priceWithoutDelivery}
          />
        </ModalBody>
        <ModalFooter className={styles.slotSelect__footer}>
          <button
            data-button="delivery"
            className="button _primary _med"
            onClick={shouldSplitSlot ? handleSplit : handleSelectSlot}
            disabled={!selectedSlotId}
          >
            {shouldSplitSlot
              ? t('checkout:splitSlot')
              : isMobile
                ? t('checkout:confirm')
                : t('checkout:deliverByThisTime')}
          </button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

export default observer(ModalSlotsSelectDateCD);
